import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import { Typography} from "@mui/material";
import { useOutletContext, useParams } from 'react-router-dom';
import path from '../../../path';
import { addTeamSchema } from '../../../services/formValidator/userValidator';

const ViewTeamModal = ({ isViewOpen, handleClose, selectedTeam, onEditClick }) => {
  const [photo, setPhoto] = useState(null);
  const [photoError, setPhotoError] = useState('');


  const handleCancel = () => {
    handleClose();
    formik.resetForm(); 
    setPhoto(null);
    setPhotoError(''); 
  }

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      userType: '',
      doctorTitle: '',
      photo: null,
    },
    validationSchema: addTeamSchema,
    
  });

  useEffect(() => {
    if (selectedTeam) {
        if (selectedTeam?.photo) {
            const imageUrl = `${path}/${selectedTeam?.photo?.split("/").pop()}`;
            
            fetch(imageUrl).then(async (response) => {
              const blob = await response.blob();
              const file = new File([blob], imageUrl.split('/').pop(), { type: blob.type });
              const dataTransfer = new DataTransfer();
              dataTransfer.items.add(file);
      
              setPhoto(imageUrl);
              formik.setFieldValue('photo', dataTransfer.files[0]);
            }).catch(error => console.error('Error fetching image:', error));
          }
      formik.setFieldValue('firstName', selectedTeam?.firstName);
      formik.setFieldValue('lastName', selectedTeam?.lastName);
      formik.setFieldValue('email', selectedTeam?.email);
      formik.setFieldValue('phoneNumber', selectedTeam?.phoneNumber);
      formik.setFieldValue('userType', selectedTeam?.role);
      formik.setFieldValue('doctorTitle', selectedTeam?.doctorTitle);
    }
  }, [selectedTeam]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isViewOpen}
    >
      <div className="d-flex align-items-center justify-content-between">
        <DialogTitle id="customized-dialog-title">View Team Member</DialogTitle>
        <IconButton aria-label="close" onClick={handleCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent dividers>
        <div className="uploadprofileimg">
          <div>
            <div className="profile-pic-container">
              <img
                src={photo ? photo : "/profile.svg"}
                alt="Profile"
                className="profile-pic"
                style={{ width: '150px', height: '150px', borderRadius: '50%' }}
              />
            </div>
            <input
              type="file"
              id="file-upload"
              disabled
              accept="image/*"
              style={{ display: 'none' }}
            />
            <button className="upload-button">
              Upload Image
            </button>
            {photoError && <div style={{ color: 'red' }}>{photoError}</div>}
          </div>
          <div className="textsides">
            <h6>Update Profile Image</h6>
            <p>The Image should be 512*512 px and not bigger than 1 MB</p>
          </div>
        </div>

        <form onSubmit={formik.handleSubmit} className="sectionalForms">
          <div className="row">
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="First Name"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  disabled
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                  helperText={formik.touched.firstName && formik.errors.firstName}
                />
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Last Name"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  disabled
                  name="lastName"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                  helperText={formik.touched.lastName && formik.errors.lastName}
                />
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Email"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="email"
                  disabled
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Phone Number"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="phoneNumber"
                  disabled
                  value={formik.values.phoneNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                  helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                />
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <FormControl fullWidth size="small" error={formik.touched.userType && Boolean(formik.errors.userType)}>
                  <InputLabel id="userType-label">User Type</InputLabel>
                  <Select
                    labelId="userType-label"
                    id="userType"
                    name="userType"
                    value={formik.values.userType}
                    label="User Type"
                    disabled
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.userType && Boolean(formik.errors.userType)}
                  >
                    <MenuItem value="doctor">Doctor</MenuItem>
                    <MenuItem value="staff">Staff</MenuItem>
                    <MenuItem value="location">Admin</MenuItem>
                    <MenuItem value="provider">Provider</MenuItem>
                  </Select>

                {formik.touched.userType && formik.errors.userType && (
                  <Typography variant="caption" color="error" style={{ marginLeft: "15px", marginTop: "4px"}}>
                    {formik.errors.userType}
                  </Typography>
                )}
                </FormControl>
               
              </div>
            </div>
            {formik.values.userType === "doctor" && (
              <div className="col-lg-6 col-sm-12">
                <div className="formdesign">
                  <TextField
                    label="Doctor’s Title"
                    className="w-100"
                    variant="outlined"
                    size="small"
                    disabled
                    name="doctorTitle"
                    value={formik.values.doctorTitle}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.doctorTitle && Boolean(formik.errors.doctorTitle)}
                    helperText={formik.touched.doctorTitle && formik.errors.doctorTitle}
                  />
                </div>
              </div>
            )}
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <div className="text-end modalactions">
        <button className="btn btn-blacked outline me-2" onClick={onEditClick}>Edit</button>
          <button className="btn btn-blacked outline me-2" onClick={handleCancel}>Cancel</button>
          
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ViewTeamModal;
